import { filterId } from "@/assets/googleTrackIds";
import { useAppTranslation } from "@/utils";
import { PhRFunnel } from "@payping/icons";
import { countActiveQueryParams } from "@payping/utilities-shared/url";
import { Badge, Button } from "@payping/web-components";
import { useSearchParams } from "react-router-dom";

type Props = {
  onClick: () => void;
  params: Record<string, any>;
};
export const FiltersButton = ({ onClick, params }: Props) => {
  const { t } = useAppTranslation();
  const [searchParams] = useSearchParams();

  return (
    <Badge className={"z-1 w-100"} count={countActiveQueryParams(Object.fromEntries(searchParams.entries()), params)}>
      <Button block icon={<PhRFunnel width={14} height={14} />} onClick={onClick} data-google-track={filterId}>
        {t("filters")}
      </Button>
    </Badge>
  );
};
